import { useParams } from 'react-router-dom';
import { DatasetStatus } from '~/api/types';
import { useGetDatasetQuery } from '~/api/v2/hooks';

const useHasLockedStatus = () => {
  const datasetId = +useParams().id!;
  const { data } = useGetDatasetQuery({ datasetId }, { skip: !datasetId });

  return {
    hasLockedStatus: data?.status
      ? [DatasetStatus.LOCKED_RESTRICTED, DatasetStatus.LOCKED_SEARCHABLE].includes(data.status) &&
        data.status_edit_allowed
      : false,
  };
};

export default useHasLockedStatus;
